import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "https://scanmymenu-nm38.onrender.com";

const API_TIMEOUT =
  parseInt(process.env.REACT_APP_API_TIMEOUT, 10) || 30000;

// ===============================
// Axios JSON instance
// ===============================

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});

// ===============================
// Request interceptor
// ===============================

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ===============================
// Response interceptor
// ===============================

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred";

    return Promise.reject(new Error(message));
  }
);

// ===============================
// Axios Form instance (uploads)
// ===============================

const axiosFormInstance = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
});

axiosFormInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "An error occurred";

    return Promise.reject(new Error(message));
  }
);

// ===============================
// API SERVICE
// ===============================

const apiService = {
  // =====================================
  // RESTAURANT APIs
  // =====================================

  // Create restaurant
  createRestaurant: (formData) => {
    return axiosFormInstance.post(
      "/api/restaurants",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  // Get all restaurants
  getAllRestaurants: () => {
    return axiosInstance.get("/api/restaurants");
  },

  // Get restaurant by ID
  getRestaurantDetails: (restaurantId) => {
    return axiosInstance.get(
      `/api/restaurants/${restaurantId}`
    );
  },

  getRestaurantByUserId: (restaurantId) => {
    return axiosInstance.get(
      `/api/restaurants/id/${restaurantId}`
    );
  },

  // Update restaurant
  updateRestaurant: (restaurantId, data) => {
    return axiosInstance.put(
      `/api/restaurants/${restaurantId}`,
      data
    );
  },

  // Delete restaurant
  deleteRestaurant: (restaurantId) => {
    return axiosInstance.delete(
      `/api/restaurants/${restaurantId}`
    );
  },

  // =====================================
  // ITEM APIs
  // =====================================

  // Get items for restaurant
  getRestaurantItems: (restaurantId) => {
    return axiosInstance.get(
      `/api/restaurants/${restaurantId}/items`
    );
  },

  // Add item
  addRestaurantItem: (restaurantId, formData) => {
    return axiosFormInstance.post(
      `/api/restaurants/${restaurantId}/items`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  // Update item
  updateRestaurantItem: (
    restaurantId,
    itemId,
    formData
  ) => {
    return axiosFormInstance.put(
      `/api/restaurants/${restaurantId}/items/${itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  // Delete item
  deleteRestaurantItem: (
    restaurantId,
    itemId
  ) => {
    return axiosInstance.delete(
      `/api/restaurants/${restaurantId}/items/${itemId}`
    );
  },

  // Get item by itemId
  getItemDetails: (itemId) => {
    return axiosInstance.get(
      `/api/restaurants/items/${itemId}`
    );
  },

  // =====================================
  // UTILITY
  // =====================================

  getAllItems: () => {
    return axiosInstance.get(
      "/api/restaurants/items"
    );
  },
submitContact: (data) => {
  return axiosInstance.post(
    "/api/contact",
    data
  );
},

// ── Place Order ──────────────────────────────
placeOrder: async ({
  restaurantId,
  tableNumber,
  cart,
}) => {
  const response = await fetch(
    `${API_URL}/api/orders`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        restaurantId,
        tableNumber,
        items: cart,
      }),
    }
  );

  return response.json();
},

// ── Get Orders ──────────────────────────────
getOrders: async (
  restaurantId,
  filters = {}
) => {
  const params =
    new URLSearchParams(filters).toString();

  const response = await fetch(
    `${API_URL}/api/orders/${restaurantId}${
      params ? "?" + params : ""
    }`
  );

  return response.json();
},

// ── Update Order Status ─────────────────────
updateOrderStatus: async (
  orderId,
  status
) => {
  const response = await fetch(
    `${API_URL}/api/orders/${orderId}/status`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    }
  );

  return response.json();
},
};



export default apiService;